import { render, staticRenderFns } from "./vuetiform-date-and-time.vue?vue&type=template&id=083abc7f&"
import script from "./vuetiform-date-and-time.vue?vue&type=script&lang=js&"
export * from "./vuetiform-date-and-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VCol,VDatePicker,VMenu,VRow,VTextField,VTimePicker})
